(function($) {
    class W4D_ProductFlyout {
        constructor() {
            this.initSelectors();
            this.bindEvents();
            this.currentProductId = null;
        }

        initSelectors() {
            this.sidebar = $('.product-flyout');
            this.sidebarCloseBtn = '.product-flyout__close';
            this.optionsBtn = 'button[data-js-availability]';
        }

        bindEvents() {
            $(document).on('click', '.product-table .product-table__row > .product-table__data:first-child', (e) => {
                if (e.ctrlKey) {
                    return true; // Open in new tab
                }
                this.loadSidebarContent(e);
            });

            $(document).on('click', this.optionsBtn, (e) => this.loadSidebarContent(e, true));
            $(document).on('click', this.sidebarCloseBtn, () => this.closeSidebar());
            $(document).on('click', '.w4d_update_cart_button', (e) => W4D_Cart.handleUpdateCart($(e.currentTarget)));
            $(document).on('keydown', (e) => this.handleKeyPress(e));
        }

        handleKeyPress(e) {
            if (e.key === 'Escape' && this.sidebar.hasClass('product-flyout--active')) {
                this.closeSidebar();
            }
        }

        closeSidebar() {
            this.sidebar.removeClass('product-flyout--active');
            this.sidebar.empty();
        }

        loadSidebarContent(e, isOptionsClick = false) {
            e.preventDefault();
            e.stopPropagation();

            const row = $(e.currentTarget).closest('.product-table__row');
            const productId = row.data('product-id');

            // Check if clicking the same product that's already open
            if (this.currentProductId === productId && this.sidebar.hasClass('product-flyout--active')) {
                this.closeSidebar();
                return;
            }

            const quantity = isOptionsClick ? 0 : row.find('.product-quantity__number').data('quantity');

            const ajaxData = {
                action: 'get_product_sidebar_html',
                nonce: w4d_frontend_ajax.nonce,
                product_id: productId,
                quantity: quantity
            }

            $.ajax({
                url: w4d_frontend_ajax.ajax_url,
                data: ajaxData,
                success: (response) => {
                    if (response.success) {
                        this.sidebar.html(response.data);
                        this.sidebar.addClass('product-flyout--active');
                        this.currentProductId = productId;
                    }
                }
            });
        }
    }

    $(document).ready(() => {
        new W4D_ProductFlyout();
    });

})(jQuery);